import request from '@/utils/worldcupRequest'

export function getSchedule(params = {}) {
  return request({
    url: '/worldcup2026/schedule',
    method: 'get',
    params
  })
}

export function getRank() {
  return request({
    url: '/worldcup2026/rank',
    method: 'get'
  })
}

export function getNews(params = {}) {
  return request({
    url: '/worldcup2026/news',
    method: 'get',
    params
  })
}

export function getNewsInfo(params) {
  return request({
    url: '/worldcup2026/newsinfo',
    method: 'get',
    params
  })
}
